import { createStyles } from '@/hooks';
import { colors } from '@/theme/colors';
import { Platform, StyleSheet } from 'react-native';

export const useStyles = createStyles(({ scale, isTablet }) => ({
  title: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  showAll: {
    color: colors.Blue,
    textDecorationLine: 'underline',
  },
  levelText: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  detailsText: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  equipmentCard:
    Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 4,
      },
      android: {
        elevation: 2,
      },
    }) ?? {},
  infoCard:
    Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.08,
        shadowRadius: 4,
      },
      android: {
        // Elevation causes shadow artifacts during collapsible opacity animation on Android.
        elevation: 1,
      },
    }) ?? {},
  addNewKitButton: {
    paddingVertical: scale(10),
    width: isTablet ? scale(240) : undefined,
    alignSelf: isTablet ? 'center' : undefined,
    marginBottom: isTablet ? scale(4) : undefined,
    marginTop: isTablet ? -scale(8) : undefined,
  },
  infoLabel: {
    color: '#000',
    fontSize: 10,
    width: '100%',
    textAlign: 'center',
  },
  infoValue: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  sheet: {
    backgroundColor: 'white',
    maxHeight: isTablet ? undefined : '80%',
    minHeight: isTablet ? undefined : scale(440),
  },
  sheetScrollViewport: {
    flex: 1,
    minHeight: 0,
  },
  sheetHeader: {
    paddingHorizontal: scale(18),
    paddingTop: scale(26),
    paddingBottom: scale(8),
  },
  headerSide: {
    width: scale(60),
  },
  headerActionText: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  sheetTitle: {
    color: colors.Blue,
    textTransform: 'uppercase',
    width: '100%',
    textAlign: 'center',
    zIndex: 1000,
  },
  formLabel: {
    color: colors.Blue,
  },
  addKitFooter: {
    paddingHorizontal: scale(40),
    paddingTop: scale(16),
    paddingBottom: scale(8),
    gap: scale(20),
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: colors['10'],
  },
  addKitButton: {
    height: scale(30),
    paddingVertical: 0,
    width: !isTablet ? undefined : '50%',
  },
}));
